import './teamview.scss'

import { ERROR, LOADING, READY, useVisualState } from '../../../../hooks/useVisualState'
import React, { useCallback, useEffect, useState } from 'react'
import { useParams, withRouter } from 'react-router-dom'

import AttachmentModal from '../AttachmentModal'
import convertDate from '../../../../helpers/DateHelper'
import PlayerCard from '../../../../components/Cards/PlayerCard/PlayerCard'
import PlayerFormModal from '../PlayerFormModal'
import { get } from '../../../../helpers/request'
import t from '../../../../helpers/i18n'

const TeamView = ({ history, match }) => {
  const [[teamState, team], setTeam] = useVisualState()
  const [[playersState, players], setPlayers] = useVisualState()
  const { clubId, teamId } = useParams()
  const [modalPlayerId, setModalPlayerId] = useState(false)
  const [attachmentModal, setAttachmentModal] = useState(false)

  const handleClose = useCallback(() => setModalPlayerId(false), [setModalPlayerId]);
  const handleCloseAttachment = useCallback(() => setAttachmentModal(false), [setAttachmentModal]);

  useEffect(() => {
    setTeam(LOADING)
    get('/soccer/clubs/' + clubId + '/teams/' + teamId)
      .then((response) => {
        setTeam(READY, response)
      })
      .catch((error) => {
        setTeam(ERROR, error)
      })
  }, [clubId, teamId, setTeam])

  useEffect(() => {
    setPlayers(LOADING)
    get('/soccer/clubs/' + clubId + '/teams/' + teamId + '/players')
      .then((response) => {
        setPlayers(READY, response)
      })
      .catch((error) => {
        setPlayers(ERROR, error)
      })
  }, [clubId, teamId, setPlayers])

  return (
    <div>
      {teamState === READY && (
        <div>
          <h2>{t('titles.Team')} {team.name}</h2>
          <button onClick={() => setModalPlayerId(-1)}>{t('buttons.Add_player')}</button>
        </div>
      )}
      {playersState === READY && (
        <div className='container-players'>
          <ul>
            {players.map((player) => (
              <PlayerCard
                key={player.player_id}
                firstName={player.firstname}
                lastName={player.lastname}
                age={
                  new Date().getFullYear() -
                  new Date(player.birthdate).getFullYear()
                }
                dateOfBirth={convertDate(player.birthdate)}
                insuranceInfo='Public (IMSS)'
                emergencyContact={player.phone}
                onClick={() =>
                  history.push(
                    '/soccer/clubs/' +
                      clubId +
                      '/teams/' +
                      teamId +
                      '/players/' +
                      player.player_id
                  )
                }
                clickAttachment={() => setAttachmentModal(-1)}
              />
            ))}
          </ul>
        </div>
      )}

      {playersState === ERROR && <div>Error: {players.code}</div>}
      {modalPlayerId && <PlayerFormModal onCloseRequested={handleClose} />}
      {attachmentModal && (
        <AttachmentModal onCloseRequested={handleCloseAttachment} />
      )}
    </div>
  )
}

export default withRouter(TeamView)
